module.exports = __webpack_public_path__ + "img/소울보우.6198940f.png";